import React from 'react';
import { Grid, Typography } from '@mui/material';
import { Layout } from 'features/common/components/Layout';
import { ProviderPayablesPaymentsList } from '../../features/salesOrder/components/ProviderPayablesPaymentsList';
import { ProviderPaymentsNav } from './ProviderPaymentsNav';

export const ProviderPaymentsPaymentsPage = (): JSX.Element => {
	return (
		<Layout>
			<Grid container spacing={2} sx={{ p: 3 }}>
				<Grid item xs={12}>
					<Typography variant="h4" gutterBottom>
						Pagos a Proveedores
					</Typography>
					<ProviderPaymentsNav />
					<Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
						Todos los pagos registrados a proveedores. Usá los filtros para conciliar por fecha, tipo de pago, moneda o
						mercado.
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<ProviderPayablesPaymentsList />
				</Grid>
			</Grid>
		</Layout>
	);
};
